module.exports = __webpack_public_path__ + "media/images/news-3-60a260e172e267304e212edb32174234.jpg";